import './index.styl';
import _ from 'lodash';

import {
	Preloader
} from '../../../../../core/utils';

import template from './index.jst';

import { TeamInfo } from '../TeamInfo';
import { ListOfBench } from '../ListOfBench';

import {
	TeamBuilder,
	TeamFieldPitch
} from '../../../views';

import {
	Rounds,
	Positions,
	Squads,
	Players
} from '../../../collections';

import {
	Favourites,
	Coach,
	FantasyTeam
} from '../../../models';

export class ViewOthersTeamsLayout extends TeamBuilder {
	get template() {
		return template;
	}

	regions() {
		return {
			controls: '#team-builder-controls',
			bench: '#team-builder-bench',
			team: '#view-team-builder-content',
			popup: '#team-builder-player-popup'
		}
	}

	initialize(options) {
		_.extend(options, this.newViewOptions());
		super.initialize();
	}

	newViewOptions() {
		return {
			team: new FantasyTeam(),
			players: new Players(),
			rounds: new Rounds(),
			squads: new Squads(),
			positions: new Positions(),
			favourites: new Favourites(),
			coach: new Coach()
		};
	}

	setLayout() {
		const is_list_view = this.model.get('is_list_view');

		this.$el.toggleClass('list-view', is_list_view);

		if (!this.getRegion('controls').hasView()) {
			let { user_id, round_points, overall_rank, overall_points, rank } = this.options;

			this.showChildView('controls', new TeamInfo({
				user_id,
				round_points,
				overall_rank,
				overall_points,
				rank
			}));
		}

		if (!this.getRegion('bench').hasView()) {
			this.showChildView('bench', new ListOfBench());
		}

		const field = new TeamFieldPitch();

		this.showChildView('team', field);

		return this;
	}

	async requestData() {
		this.history_round = this.getOption('current_round');
		let team_id = this.getOption('team_id'),
			data = { id: team_id }
		;

		if (this.history_round) {
			data.round = this.history_round;
		}


		let queries = [
			this.options.squads.fetch(),
			this.options.rounds.fetch(),
			this.options.players.fetch(),
			this.options.favourites.fetch(),
			this.options.team.setShowUrl().getData({
				type: 'request:history:team',
				data
			})
		];

		if (this.options.coach) {
			queries.push(this.options.coach.fetch());
		}

		Preloader.show();
		clearTimeout(this.liveScoresIntervalId);
		await Promise.all(queries);
		this.trigger('data:requested');
		Preloader.hide();
	}

	initViews(params) {
		params.actual_round_id = this.options.rounds.points_round.get('id');
		return this.initControlsView(params)
			.initBenchView(params)
			.initTeamView(params);
	}

	initTeamView(args) {
		this.getChildView('team').init(args);
		return this;
	}

	initBenchView(args) {
		this.getChildView('bench').init(args);
		return this;
	}

	onToggleCoachBanner() {
		return this;
	}

	toggleMobileView() {
		return this;
	}
}

export default ViewOthersTeamsLayout;